<template>
  <div class="person-user-menu" :class="[`is-${level}`, { 'is-fetching': _get(PersonDetails, 'fetching') }]">
    <div class="person-user-menu__gender-icon">
      <i :title="$t(`label.${gender}`)" :class="`fas ${gender === 'male' ? 'fa-mars' : 'fa-venus'}`"></i>
    </div>
    <div class="top">
      <div class="image-wrap">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <filter id="blur">
              <feGaussianBlur stdDeviation="10" />
          </filter>
        </svg>
        <div class="background-mask">
          <div class="background-mask__shade" v-if="pictureBackgroundImage"></div>
          <div class="full-picture blur" :style="pictureBackgroundImage"></div>
        </div>
        <div class="image-circle">
          <div class="image" :style="pictureBackgroundImage"></div>
          <i :class="participantIconClass"></i>
        </div>
        <div class="circle-years">
          <span v-if="_get(PersonDetails, 'fetching')"><i class="far fa-spinner fa-spin"></i></span>
          <el-tooltip v-else class="item" effect="dark" :content="$t('label.person_info', { age: _get(PersonDetails, 'data.age') })" placement="right">
            <span>{{ _get(PersonDetails, 'data.age') }}</span>
          </el-tooltip>
        </div>
      </div>
      <div v-show="_get(PersonDetails, 'fetching')">
        <span class="text-dummy-loader"></span>
        <span class="text-dummy-loader is-slim-wide"></span>
      </div>
      <div v-show="!_get(PersonDetails, 'fetching')">
        <template v-if="mode === 'participant'">
          <p class="name">
            <span>{{ _get(PersonDetails, 'data.full_name') }}</span>
          </p>
          <p class="email">
            <span>{{ _get(PersonDetails, 'data.email') }}</span>
          </p>
        </template>
        <template v-else>
          <p class="name">
            <span>{{ _get(PersonDetails, 'data.full_name') }}</span>
          </p>
        </template>
      </div>
    </div>
    <p class="ui-element horizontal-divider">
      <span>{{ $t(label) }}</span>
    </p>
  </div>
</template>

<script>
import { getPersonIcon, getPersonSymbol, getPersonGender, getPersonProfilePicture, getPersonLevel } from 'utils/person';

export default {
  name: 'person-profile-card',
  props: {
    PersonDetails: {
      type: Object,
      required: true,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: 'label.participant',
    },
    mode: {
      type: String,
      required: false,
      default: 'participant',
    },
  },
  computed: {
    gender() {
      return getPersonGender(this.PersonDetails);
    },
    level() {
      return getPersonLevel(this.PersonDetails);
    },
    personSymbol() {
      return getPersonSymbol(this.PersonDetails);
    },
    participantIconClass() {
      return getPersonIcon(this.PersonDetails);
    },
    pictureBackgroundImage() {
      const profilePicture = getPersonProfilePicture(this.PersonDetails);
      return profilePicture ? `backgroundImage: url(${profilePicture})` : '';
    },
  },

};
</script>

<style lang="scss" scoped>
@import "~styles/theme/colors";
@import "~styles/theme/person-colors";
@import '~styles/mixins/gradients';

.person-user-menu {
  width: 100%;
  position: relative;

  .person-user-menu__gender-icon {
    position: absolute;
    top: 1.5em;
    right: 1.5em;
    z-index: 2;
    i {
      color: #fff;
      font-size: 1.25rem;
    }
  }

  .top {
    text-align: center;

    .image-wrap {
      padding: 1em 0 0;
      position: relative;

      svg {
        display: none;
      }

      .blur {
        transition: 1s;
        top: 0; left: 0;
        position: absolute;
        filter: url(#blur);
        filter: blur(10px);
        filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='10');
      }

      .full-picture {
        top: -5%;
        left: -5%;
        width: 110%;
        height: 110%;
        position: absolute;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }

      .circle-years {
        z-index: 2;
        position: absolute;
        bottom: 1em;
        left: 60%;
        width: 2em;
        height: 2em;
        background-color: #fff;
        // color: #fff;
        border-radius: 50%;
        span {
          line-height: 2em;
          font-weight: 600;
        }
      }

      .image-circle {
        z-index: 1;
        width: 10em;
        height: 10em;
        margin-top: 4em;
        overflow: hidden;
        position: relative;
        border-radius: 50%;
        display: inline-block;
        border: 0.5em solid #fff;
        transition: background 0.5s ease;


        .image {
          width: 100%;
          height: 100%;
          top: 0; left: 0;
          position: absolute;
          background-size: auto 100%;
          background-repeat: no-repeat;
          background-position: center center;
        }

        i {
          font-size: 7rem;
          line-height: 8.5rem;
          color: #fff;
        }
      }

      .background-mask {
        z-index: 0;
        height: 12em;
        margin: 0.5em;
        top: 0; left: 0;
        overflow: hidden;
        position: absolute;
        width: calc(100% - 1em);
        background-repeat: no-repeat;
        border-top-left-radius: 0.25em;
        border-top-right-radius: 0.25em;
        transition: background 0.5s ease;
        clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);
        -webkit-clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);

        .background-mask__shade {
          top: 0;
          left: 0;
          right: 0;
          z-index: 2;
          height: 3.5em;
          position: absolute;
          background-color: rgba(0, 0, 0, 0.25);
        }
      }
    }

  }

  .text-dummy-loader {
    width: 60%;
    height: 1em;
    display: inline-block;
    background-color: rgba(0,0,0,0.35);
    &.is-slim-wide {
      width: 70%;
      height: 0.75em;
      background-color: rgba(0,0,0,0.15);
    }
  }

  .horizontal-divider, hr {
    margin: 0.75em 0.75em;
    span {
      color: gray;
      font-weight: 600;
      font-size: 0.8rem;
      text-transform: uppercase;
    }
  }

  .name {
    font-weight: 800;
    font-size: 1.10em;
  }
  .email {
    color: $gray-light;
  }
  aside {
    margin: 0 1em;
  }

  &.is-fetching {
    .background-mask {
      @include gradient-vertical($gray-light, $gray);
    }
    .top {
      .image-circle {
        background-color: $gray-light;
        i {
          font-size: 5rem;
        }
      }
    }
  }

  @mixin theme($bg-top, $bg-bottom, $bg-col, $icon-size: 7rem, $bg-img: '~assets/images/svg-shapes/shape-01-transparent-black-20.svg') {
    .background-mask {
      @include gradient-vertical($bg-top, $bg-bottom);
      background-size: 150% auto;
      background-position: center center;
      background-image: url($bg-img);
    }
    .top {
      .image-circle {
        background-color: $bg-col;
        i {
          font-size: $icon-size;
        }
      }
    }
  }

  &.is-female {
    @include theme($female-dark, $female-light, $female);
  }

  &.is-genderless {
    @include theme($genderless-dark, $genderless-light, $genderless);
  }

  &.is-male {
    @include theme($male-dark, $male-light, $male);
  }

  &.is-professional_leader {
    @include theme($professional-leader-dark, $professional-leader-light, $professional-leader);
  }

  &.is-instance_admin {
    @include theme($admin-dark, $admin-light, $admin, 5rem);
  }

  &.is-instance_owner {
    @include theme($owner-dark, $owner-light, $owner-dark, 6rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/card/person-profile-card.vue